import { BorderOutlined } from '@ant-design/icons';
import React from 'react';
import { FormValidatorBuilder } from '../../../../../validator';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { ColumnWidgetComponent } from './ColumnWidgetComponent';
import {
  ColumnWidgetConfigComponent,
  ColumnWidgetConfigSchema,
} from './ColumnWidgetConfigComponent';
import { IColumnWidget } from './IColumnWidget';

/**
 * Tipo del componente Comtainer Colonna.
 */
export const ColumnWidgetType: IWidgetType<IColumnWidget> = {
  type: WidgetType.Column,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Container,
  name: 'Colonna',
  icon: <BorderOutlined />,
  hasValue: false,
  formComponent: ColumnWidgetComponent,
  createFormSchema: ({ widget, parentScope, section, page }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  configComponent: ColumnWidgetConfigComponent,
  configValidator: ColumnWidgetConfigSchema,
  previewComponent: ColumnWidgetComponent,
  translationSchema: tran.widget({}),
  rules: [],
};
